import { CmsMeta } from '../cmsMeta';
import './CmsFaqHeading.css';

type CmsFaqHeadingProps = {
	title: string;
};

export const CmsFaqHeading = ({ title }: CmsFaqHeadingProps): JSX.Element => {
	return <h2 className="cms-faq__title">{title}</h2>;
};

CmsFaqHeading.displayName = 'CmsFaqHeading';

export const cmsMeta: CmsMeta = {
	description: 'A section heading inside CmsFaq. Questions after it belong to it until the next heading.',
	example: ['CmsFaqHeading', { index: 0, title: 'Bestellen & Kunde werden' }],
};
